import React from 'react'
import logo from '../images/easyGray.png'
// import privacy from './../../public/legal/privacyPolicy.html'
import '.././Styles/HomePage.scss'

export const Footer = () => {


  return (
    <div>
      <div className='footer-div'>
        <img src={logo} alt="RentEasii" className='logo-footer' />
        <div className='flex flex-column align-items-center'>
          <span className='all-rights mr-2'>RentEasii: All Rights Reserved</span>
          <section className='flex cursor-pointer'>
            <a href="/legal/privacyPolicy.html" className='m-0 text-xs hover-pol'
              target="_blank"
              rel="noopener noreferrer" >Privacy Policy |</a>&nbsp;

            <a href="/legal/termsOfSservice.html" className='m-0 text-xs hover-pol'
              target="_blank"
              rel="noopener noreferrer" >Terms of Service</a>

          </section>
        </div>
      </div>
    </div>
  )
}
